import {
  WorkflowNodeData,
  WorkflowNodeTypes,
  SettingParamTypes,
} from "@/types/node";
import {Node} from "@xyflow/react";

export const actionNodeBlueprint: Partial<Node<WorkflowNodeData>> = {
  type: WorkflowNodeTypes.ACTION,
  data: {
    type: WorkflowNodeTypes.ACTION,
    settingsTitle: "Action Settings",
    description: "This is the action node",
    onChange: () => {
      console.log("Start node changed");
    },
    settings: [
      {
        title: "General Action Settings",
        icon: "Settings2",
        description:
          "Customize the overall behavior and objectives of your AI Voice Assistant.",
        params: [
          {
            label: "Personality",
            type: SettingParamTypes.SELECT,
            key: "personality",
            value: "",
          },
          {
            label: "Role & Goal",
            type: SettingParamTypes.SELECT,
            key: "role_and_goal",
            value: "",
          },
        ],
      },
    ],
  },
  position: {x: 0, y: 0},
};
